
import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './ShareModule.css';
import { Col, Row, Section, Icon } from '../../importCL';
import { LinkWrapper } from '../LinkWrapper/LinkWrapper';

interface Icon {
    iconAltText: string;
    iconLabel: string;
    iconPath: string;
    iconRedirect: string;
    uuid: string;
}

interface IShareModuleProps extends MappedComponentProperties {
    icons?: Icon[];
    label?: string;
}

export const ShareModuleEditConfig = {
    emptyLabel: 'Share Module',
    isEmpty: (props: PropsWithChildren<IShareModuleProps>) => {
        return !props || !props.icons;
    },
};

const ShareModule = (props: PropsWithChildren<IShareModuleProps>): JSX.Element => {

    return (<div>
        <Section id='shareModule' className='ShareModule'>
            <Row className='ShareModule__row'>
                <Col className='ShareModule__col mb-4'>
                    <div className = 'ShareModule__content'>
                        {props.label}
                        {props.icons && props.icons.map((icon: Icon, index: number) => (
                            <LinkWrapper key={index} href={icon?.iconRedirect} target='_blank' rel='noopener noreferrer'>
                                <Icon loading='lazy' src={icon?.iconPath} alt={icon?.iconAltText}/>
                            </LinkWrapper>
                        ))}
                    </div>
                </Col>
            </Row>
        </Section>
    </div>);
};

export default ShareModule;
        